import { createContext, useCallback, useContext, useMemo, useState } from 'react';

// A cross-component "refresh the Backlog" signal. SWR's global key-matcher
// mutate does not reliably revalidate `useSWRInfinite` instances in other
// components, so action completers (e.g. the invoice review / dispute flows)
// bump this token and every action-items consumer (the Backlog list and the
// sidebar badge) revalidates its own SWR cache in response.
type ActionItemsRefreshContextValue = {
  token: number;
  refresh: () => void;
};

const ActionItemsRefreshContext = createContext<ActionItemsRefreshContextValue>({
  token: 0,
  refresh: () => {},
});

export const useActionItemsRefresh = () => useContext(ActionItemsRefreshContext);

export function ActionItemsRefreshProvider({ children }: { children: React.ReactNode }) {
  const [token, setToken] = useState(0);
  const refresh = useCallback(() => setToken((t) => t + 1), []);
  const value = useMemo(() => ({ token, refresh }), [token, refresh]);

  return (
    <ActionItemsRefreshContext.Provider value={value}>
      {children}
    </ActionItemsRefreshContext.Provider>
  );
}
